var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-small_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M17.72-73.589a.545.545 0 01.456.169.545.545 0 01.169.456l-.733 5.395a.345.345 0 01-.292.3.54.54 0 01-.466-.168l-.489-.487q-.027.031-.057.06L4.533-56.088a1.388 1.388 0 01-1.963 0L.607-58.05a1.388 1.388 0 010-1.963l11.776-11.776q.03-.03.06-.057l-.313-.322a.54.54 0 01-.168-.466.345.345 0 01.3-.292z",
    transform: "translate(-.201 73.594)",
    clipRule: "evenodd",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-small_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M27.394-34.274l6.379-6.379a1.388 1.388 0 011.963 0l1.717 1.717a1.388 1.388 0 010 1.963l-6.379 6.379a1.388 1.388 0 01-1.963 0l-1.717-1.717a1.388 1.388 0 010-1.963z",
    transform: "translate(-26.988 41.059)",
    clipRule: "evenodd",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17296"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31539",
    d: "M18 0a18 18 0 0118 18v18H18A18 18 0 010 18 18 18 0 0118 0z",
    fill: "#5f48e9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17186",
    transform: "translate(8.857 7.153)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7",
    transform: "translate(-2 -1)",
    clipPath: "url(#logo-small_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M-1.736-1.572h21.22v21.22h-21.22z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8",
    transform: "translate(7.075 9.822)",
    clipPath: "url(#logo-small_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M-1.735-1.735h14.341v14.341H-1.735z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 89",
    cx: 2.545,
    cy: 2.545,
    r: 2.545,
    transform: "translate(16.15 18.652)",
    fill: "#0f0"
  })))));
}

export default SvgLogoSmall;